<template>
    <div>
      <div class="card">
        <div class="card-header">
          <ol class="breadcrumb breadcrumb-card-header pull-left">
            <li class="breadcrumb-item"><a href="javascript:void(0);" @click="backParent">Project</a></li>
            <li class="breadcrumb-item" v-if="ref_no !== null"><a href="javascript:void(0);" @click="toSales">[Sales]</a></li>
            <li class="breadcrumb-item active" v-if="project.id === null">New</li>
            <li class="breadcrumb-item active" v-else>Edit</li>
          </ol>
          <button type="button" class="btn btn-sm pull-right"  data-toggle="modal" data-target="#modalProjectAttachmentModal" data-backdrop="static" data-keyboard="false" >
            <i class="fa fa-paperclip" aria-hidden="true"></i> Attachment
          </button>
        </div>
        <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <h5>Data</h5>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <label for="project_name" class="col-sm-3 col-form-label text-left">Project Name</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control" v-model="project.project_name" :disabled="project.lock" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="schedule_date" class="col-sm-3 col-form-label text-left">Schedule Date</label>
                  <div class="col-sm-9">
                    <datetime v-model="project.schedule_date" format="dd/MM/yyyy" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta" :disabled="project.lock"></datetime>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="estimated_date" class="col-sm-3 col-form-label text-left">Estimated Date</label>
                  <div class="col-sm-9">
                    <datetime v-model="project.estimated_date" format="dd/MM/yyyy" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta" :disabled="project.lock"></datetime>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="type_id" class="col-sm-3 col-form-label text-left">Type</label>
                  <div class="col-sm-9">
                    <select v-model="project.type_id" class="form-control" :disabled="project.lock">
                      <option v-for="t in projectTypeList" :key="t.id" :value="t.id">
                        {{ t.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="start_project" class="col-sm-3 col-form-label text-left">Start</label>
                  <div class="col-sm-9">
                    <datetime type="datetime" v-model="project.start_project" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta" disabled="disabled"></datetime>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="end_project" class="col-sm-3 col-form-label text-left">End</label>
                  <div class="col-sm-9">
                    <datetime type="datetime" v-model="project.end_project" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta" disabled="disabled"></datetime>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-md-12">
                <h5>Engineer</h5>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <label for="pic" class="col-sm-3 col-form-label text-left">Person In Charge (PIC)</label>
                  <div class="col-sm-9">
                    <select v-model="project.pic" class="form-control" :disabled="project.lock">
                      <option v-for="u in userList" :key="u.id" :value="u.id">{{ u.name }}</option>
                    </select>
                  </div>
                </div>
                <table class="table table-sm table-item table-striped">
                  <thead>
                    <th>Engineer ID</th>
                    <th></th>
                  </thead>
                  <tbody>
                    <tr v-for="e in engineerList" :key="e.id">
                      <td>
                        <select v-model="e.engineer_id" class="form-control">
                          <option v-for="et in getEngineer" :key="et.id" :value="et.id">[{{ et.username }}] {{ et.name }}</option>
                        </select>
                      </td>
                      <td>
                        <button type="button" class="btn btn-sm btn-danger" @click="removeEngineer(e.id)"><i class="fa fa-trash"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td><span style="cursor: pointer; color: blue" @click="addEngineer">Add Enginner</span></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <label for="customer_no" class="col-sm-3 col-form-label text-left">Customer</label>
                  <div class="col-sm-9">
                    <!-- <input type="text" class="form-control" v-model="project.customer_no"/> -->
                    <v-select :options="getCustomerSelect" :reduce="customer => customer.meta.code" label="customer" v-model="project.customer_no" @input="selectCustomer"/>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="customer_name" class="col-sm-3 col-form-label text-left">Name</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control" v-model="project.customer.name" disabled="disabled" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="customer_phone" class="col-sm-3 col-form-label text-left">Phone</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control" v-model="project.customer.phone" disabled="disabled" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="customer_address" class="col-sm-3 col-form-label text-left">Address</label>
                  <div class="col-sm-9">
                    <textarea class="form-control" v-model="project.customer.address" disabled="disabled" />
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-md-12">
                <h5>Handover</h5>
                <table class="table table-sm table-item table-striped">
                  <thead>
                    <th>Product No</th>
                    <th>Product</th>
                    <th>Qty</th>
                    <th>Uom</th>
                    <th>Serial Number</th>
                    <th>IP Address</th>
                    <th>Description</th>
                    <th></th>
                  </thead>
                  <tbody>
                    <tr v-for="h in getHandover" :key="h.id">
                      <td>
                        <p class="input-group">
                          <input type="text" class="form-control" v-model="h.product_no" disabled="disabled" />
                          <span class="input-group-btn ml-1">
                            <button data-toggle="modal" data-target="#modalGetProduct" data-backdrop="static" data-keyboard="false" type="button" class="btn btn-outline-primary btn-sm" @click="setIdDetail(h.id)"><i class="fa fa-search" aria-hidden="true"></i></button>
                          </span>
                        </p>
                      </td>
                      <td>
                        <input type="text" class="form-control" v-model="h.product.product_name " disabled="disabled"/>
                      </td>
                      <td>
                        <input type="text" class="form-control" v-model="h.qty"/>
                      </td>
                      <td>
                        <select class="form-control" v-model="h.uom_id">
                          <option v-for="u in h.uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                        </select>
                      </td>
                      <td>
                        <input type="text" class="form-control" v-model="h.serial_number"/>
                      </td>
                      <td>
                        <input type="text" class="form-control" v-model=" h.ip_address"/>
                      </td>
                      <td>
                        <input type="text" class="form-control" v-model="h.description"/>
                      </td>
                      <td>
                        <button type="button" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td><span style="color: blue; cursor: pointer;" @click="addLine">Add line</span></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-md-12">
                <div>Notes:</div>
                <wysiwyg v-model="project.notes" />
              </div>
            </div>
        </div>
        <div class="card-footer">
          <button type="button" class="btn btn-danger btn-sm" @click="backParent" v-if="ref_no === null"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> Back</button>
          <button type="button" class="btn btn-danger btn-sm" @click="toSales" v-else><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> Back</button>
          <button type="button" class="btn btn-sm btn-primary" v-if="project.id === null" @click="saveProject">Save</button>
          <button type="button" class="btn btn-sm btn-primary" v-else @click="updateProject">Update</button>
          <button type="button" class="btn btn-sm btn-info pull-right" v-if="project.start_project === null" @click="startProject">Start Project</button>
          <button type="button" class="btn btn-sm btn-info pull-right" v-if="project.start_project !== null" @click="finishProject">Finish Project</button>
        </div>
      </div>
      <ProjectAttachmentModal :project="project"/>
      <SalesProductModal @selectProduct="selectProduct" />
      <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in project.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div>
      <pre>{{ project }}</pre>
    </div>
</template>

<script>
import Axios from 'axios'
import { mapState } from 'vuex'
import { getHeader, projectUrl } from '../../config'
import ProjectAttachmentModal from '@/components/project/ProjectAttachmentModal.vue'
import SalesProductModal from '@/components/sales/SalesProductModal.vue'

export default {
  name: 'ProjectForm',
  props: ['project'],
  components: {
    ProjectAttachmentModal,
    SalesProductModal
  },
  data () {
    return {
      ref_no: null,
      idHoverDetail: null,
      idDetail: null,
      detail: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      branchList: state => state.branches.branchList,
      productList: state => state.products.productListAll,
      uomList: state => state.uom.uomList,
      userList: state => state.users.userAll,
      projectTypeList: state => state.projects.projectTypeList,
      customerList: state => state.customers.customerList
    }),
    getHandover: function () {
      return this.project.handovers.filter(d => d.id !== null)
    },
    getCustomerSelect: function () {
      var array = this.customerList
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          customer: array[i].name,
          meta: {
            code: array[i].customer_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    picList: function () {
      return this.userList.filter(d => d.position_id === 3)
    },
    getEngineer: function () {
      return this.userList
    },
    engineerList: function () {
      return this.project.engineers.filter(d => d.id !== null)
    }
  },
  methods: {
    startProject: function () {
      var date = new Date()
      this.project.start_project = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()
      this.project.status = 'start'
      Axios.put(projectUrl + '/' + this.project.id, this.project, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            'Start Project at ' + this.project.start_project,
            'success'
          )
          this.backParent()
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    finishProject: function () {
      var date = new Date()
      this.project.end_project = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()
      this.project.status = 'finish'
      Axios.put(projectUrl + '/' + this.project.id, this.project, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            'Finish Project at ' + this.project.start_project,
            'success'
          )
          this.backParent()
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    toSales: function () {
      this.$router.push({ name: 'sales', query: { sales: this.ref_no } })
    },
    getType: function () {
      var obj = {
        priceID: null,
        branch: this.project.branch_no,
        warehouse: null
      }
      this.$store.dispatch('getProductByPriceList', obj)
    },
    selectProduct: function (value) {
      var handover = this.project.handovers.find(d => d.id === this.idHoverDetail)
      handover.project_no = this.project.project_no
      handover.product_no = value.product_no
      handover.product = {
        id: value.id,
        product_no: value.product_no,
        product_name: value.product_name
      }
      handover.qty = 1
      handover.uom_id = value.uom_id
      handover.uomList = value.uomList
    },
    setIdDetail: function (id) {
      this.idHoverDetail = id
      this.getType()
    },
    addLine: function () {
      const newID = Math.floor(Math.random() * (99999999 - 66666666) + 66666666)
      var obj = {
        id: newID,
        project_no: null,
        product_no: null,
        product: {
          id: null,
          product_no: null,
          product_name: null
        },
        qty: null,
        uom_id: null,
        serial_number: null,
        description: null,
        ip_address: null,
        state: 'create'
      }
      this.project.handovers.push(obj)
    },
    saveProject: function () {
      Axios.post(projectUrl, this.project, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.backParent()
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    updateProject: function () {
      Axios.put(projectUrl + '/' + this.project.id, this.project, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.backParent()
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    selectCustomer: function () {
      var customerNo = this.project.customer_no
      var customer = this.customerList.find(d => d.customer_no === customerNo)
      this.project.customer.name = customer.name
      this.project.customer.phone = customer.phone
      this.project.customer.address = customer.address
    },
    removeEngineer: function (id) {
      var detail = this.project.engineers.find(d => d.id === id)
      var index = this.project.engineers.findIndex(d => d.id === id)
      if (detail.state === 'create') {
        this.project.engineers.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            console.log(projectUrl + '/engineer/' + detail.id)
            Axios.delete(projectUrl + '/engineer/' + detail.id, { headers: getHeader() })
              .then(response => {
                this.project.engineers.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    removeHandover: function (id) {
      var detail = this.project.handovers.find(d => d.id === id)
      var index = this.project.handovers.findIndex(d => d.id === id)
      if (detail.state === 'create') {
        this.project.handovers.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            console.log(projectUrl + '/handover/' + detail.id)
            Axios.delete(projectUrl + '/handover/' + detail.id, { headers: getHeader() })
              .then(response => {
                this.project.handovers.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    addEngineer: function () {
      const newID = Math.floor(Math.random() * (99999999 - 66666666) + 66666666)
      var obj = {
        id: newID,
        engineer_id: null,
        engineer: null,
        state: 'create'
      }
      this.project.engineers.push(obj)
    },
    backParent: function () {
      this.$emit('backClicked')
    }
  },
  mounted () {
    this.ref_no = this.$route.query.ref
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
</style>
